import { TransferHistoryFilter } from '../shared/models';
import { Component, ViewChild, OnDestroy } from '@angular/core';
import { Store, StoreHelper, UserService } from '../../shared/services';
import { HeaderAction, TopLevelComponent } from '../../shared/models';
import { AppPageComponent, DateRangeSheetComponent } from '../../shared/ui';
import { DateRange } from '../../shared/models';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Transfer } from '../shared/models';
import { TransferHistoryService } from './transfer-history.service';

@Component({
  styles: [
    require('./transfer-history.component.scss')
  ],
  template: require('./transfer-history.component.pug'),
})
export class TransferHistoryComponent extends TopLevelComponent {
  @ViewChild(AppPageComponent) appPage;
  @ViewChild(DateRangeSheetComponent) dateRangeSheet;

  transfer: Array<Transfer>;
  transferHistoryFilter: TransferHistoryFilter;
  transferSelected: Transfer = <Transfer>{};
  showDetail: boolean = false;
  loading = true;
  authorized = true;

  private _preloaderSubs: Subscription;
  private _calendarAction = { id: 'calendar', icon: 'calendar' };
  private _dateRange: DateRange;
  private _initialFilter = true;

  constructor(
    public _transferHistoryService: TransferHistoryService,
    store: Store,
    storeHelper: StoreHelper,
    userService: UserService) {
    super(store, storeHelper, userService);
    this.headerTitle = 'Transfer History';
    this.headerActions = [this._calendarAction];
    this.subscribeToHeaderActions(this._reactToHeaderAction);
  }


  onApplyDateRange(range: DateRange) {
    this._dateRange = range;
    this._loadTransfers();
  }

  coverClosed() {
    this.showDetail = false;
    this.headerTitle = 'Transfer History';
  }

  showTransferDetail(transfer: Transfer) {
    this.transferSelected = transfer;
    this.showDetail = true;
  }

  refreshAfterDelteTransfer() {
    this._initialFilter = true;
    this.showDetail = false;
    this.headerTitle = 'Transfer History';
    this._loadTransfers();
  }

  private _reactToHeaderAction(action: HeaderAction) {
    if (action.id === this._calendarAction.id && this.authorized) {
      this.dateRangeSheet.toggle();
    }
  }

  private _toggleSheet() {
    this.dateRangeSheet.toggle();
  }

  private _loadTransfers() {
    let that = this;
    this.empty = false;
    this.appPage.activatePreloader();

    if (this._dateRange && this._dateRange.isValid) {
      this.transferHistoryFilter = new TransferHistoryFilter(this._dateRange);
    } else {
      this.transferHistoryFilter = new TransferHistoryFilter();
    }

    this.loading = true;
    this._transferHistoryService.getTransfer(this.transferHistoryFilter)
      .subscribe(transfers => {
        this.transfer = transfers;
        that.appPage.deactivatePreloader();
        this.empty = transfers.length <= 0;

        if (this.empty) {
          setTimeout(() => this._toggleSheet(), 1500);
        }
      },
      err => {
                this.authorized = this.userService.userHasAccess(err);
                this.appPage.deactivatePreloader();
                this.loading = false;
      },
      () => that.loading = false);

    if (!this._initialFilter) {
      this._toggleSheet();
    }

    this._initialFilter = false;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/transfer-history/transfer-history.component.ts